import {
  SHOW_SIDE_MENU,
  HIDE_SIDE_MENU,
  SET_SIDE_MENU_LINKS,
  SET_SIDE_MENU_ITEMS,
  HIDE_SIDE_MENU_CONVERSATION,
  SHOW_SIDE_MENU_CONVERSATION
} from "../../../action/menu/side/sideType";

const initialState = {
  showMenu: false,
  showMenuConversation: false,

  menuItems: [],

  menuLinks: [],
};

const sideMenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SIDE_MENU:
      return {
        ...state,
        showMenu: true,
      };

    case HIDE_SIDE_MENU: {
      return {
        ...state,
        showMenu: false,
      };
    }

    case SET_SIDE_MENU_LINKS:
      return {
        ...state,
        menuLinks: action.payload,
      };

    case SET_SIDE_MENU_ITEMS:
      return {
        ...state,
        menuItems: action.payload,
      };

    case SHOW_SIDE_MENU_CONVERSATION:
      return {
        ...state,
        showMenuConversation: true,
      };

    case HIDE_SIDE_MENU_CONVERSATION: {
      return {
        ...state,
        showMenuConversation: false,
      };
    }

    default:
      return state;
  }
};

export default sideMenuReducer;
